import axios from 'axios';

import { API } from '@/config/constants';

// Admin-only desktop device-registry controls. Enrollment and heartbeat are
// owned by Electron's main process so the private credential never reaches React.

export const getDevices = async (config) => {
  const res = await axios.get(`${API}/devices`, ...(config ? [config] : []));
  return res.data;
};

export const renameDevice = async (installId, displayName, config) => {
  const res = await axios.patch(
    `${API}/devices/${encodeURIComponent(installId)}`,
    { display_name: displayName },
    ...(config ? [config] : []),
  );
  return res.data;
};

export const retireDevice = async (installId, config) => {
  const res = await axios.delete(`${API}/devices/${encodeURIComponent(installId)}`, ...(config ? [config] : []));
  return res.data;
};

export const assignPrimary = async (installId, config) => {
  const res = await axios.post(`${API}/devices/${encodeURIComponent(installId)}/primary`, ...(config ? [undefined, config] : []));
  return res.data;
};

export const killPrimary = async (config) => {
  const res = await axios.post(`${API}/devices/kill-primary`, ...(config ? [undefined, config] : []));
  return res.data;
};
